import React from 'react';
import { CALENDAR } from '../Pages';

export default {
  path: CALENDAR.pageURL,
  async action() {
    const { default: Calendar } = await import('./Calendar');
    return <Calendar key={'calendar'} />;
  },
};
